import {gql} from '@apollo/client';

export default gql`
  mutation deleteGenericTag($input: DeleteGenericTagInput!) {
    authed {
      success
    }
    deleteGenericTag(input: $input) {
      success
    }
  }
`;
